<template>
  <button
    type="button"
    class="deal-quick-action"
    :class="`deal-quick-action--${variant}`"
    @click="$emit('click')"
  >
    <span class="deal-quick-action__icon-wrap">
      <v-icon class="deal-quick-action__icon">{{ icon }}</v-icon>
    </span>
    <span class="deal-quick-action__label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: "DealQuickActionTile",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        [
          "purchase-order",
          "sales-order",
          "receipt",
          "delivery",
          "transport",
        ].includes(value),
    },
  },
};
</script>

<style scoped>
.deal-quick-action {
  --action-color: #1976d2;
  --action-bg: rgba(25, 118, 210, 0.08);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 1 1 0;
  min-width: 108px;
  max-width: 160px;
  min-height: 96px;
  padding: 14px 10px;
  border: 1px solid #e3e6ef;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: center;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}

.deal-quick-action:focus {
  outline: none;
}

.deal-quick-action:focus-visible {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--action-color);
}

.deal-quick-action:hover {
  border-color: var(--action-color);
  background: var(--action-bg);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.deal-quick-action:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.deal-quick-action__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.04);
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.deal-quick-action__icon {
  font-size: 24px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  transition: color 0.2s ease, filter 0.2s ease;
}

.deal-quick-action:hover .deal-quick-action__icon-wrap {
  background: var(--action-bg);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04);
}

.deal-quick-action:hover .deal-quick-action__icon {
  color: var(--action-color) !important;
  filter: drop-shadow(0 2px 8px var(--action-bg));
}

.deal-quick-action__label {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  color: rgba(0, 0, 0, 0.72);
  transition: color 0.2s ease;
}

.deal-quick-action:hover .deal-quick-action__label {
  color: var(--action-color);
}

.deal-quick-action--purchase-order {
  --action-color: #3949ab;
  --action-bg: rgba(57, 73, 171, 0.1);
}

.deal-quick-action--sales-order {
  --action-color: #00897b;
  --action-bg: rgba(0, 137, 123, 0.1);
}

.deal-quick-action--receipt {
  --action-color: #f57c00;
  --action-bg: rgba(245, 124, 0, 0.1);
}

.deal-quick-action--delivery {
  --action-color: #7b1fa2;
  --action-bg: rgba(123, 31, 162, 0.1);
}

.deal-quick-action--transport {
  --action-color: #0288d1;
  --action-bg: rgba(2, 136, 209, 0.1);
}
</style>
